export const VIDEO_EMBEDS = {
  SUMMARY: {
    name: 'Learn how the Summary works',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxTgVa5JK_rVv7XxOq6wytvD2MRp1PLly7&amp;clipt=EOOwCBiVtwo',
  },
  BAV: {
    name: 'How to verify a Bank Account?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=Ugkxpi3hIESGDZubCrH8ui2-gsijNghMqgOe&amp;clipt=ELnBChicxw0',
  },
  BANK_ACCOUNT_BATCH: {
    name: 'How to verify Bank Accounts in bulk?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxQdyLLUx0O7bp5zNIABsrlZOIGOjH0TF-&amp;clipt=EJPODRisoBE',
  },
  BANK_ACCOUNT_APPROVE: {
    name: 'How to Approve Batch upload?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=Ugkx3sbDhru_a7i8tyibJnuNDDWSeUUK2cYI&amp;clipt=EJ3AERjkihU',
  },
  'UPI VPA': {
    name: 'How to verify a UPI VPA?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxY6b2e0nN4dH3gGrIMI7h_mobkWcqlBbn&amp;clipt=EOKJFRiLzRc',
  },
  UPI_BATCH: {
    name: 'How to verify a UPI VPA in bulk?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxpwpdCwwp4ZlbVRV93a0oDQXDNKDhYJy3&amp;clipt=EOHPFxiHvBo',
  },
  'UPI MOBILE': {
    name: 'How to verify a UPI with Mobile Number?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxjrNIr27n0gD2ezV1TN4BuSbNB_x-BdUI&amp;clipt=EJq3GhjBzRs',
  },
  IFSC: {
    name: 'How to verify an IFSC?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxvpT6Ngg2XZApEI8bD_-PbRuE4cbFiI5b&amp;clipt=EJzUGxjwzR0',
  },
  PAN: {
    name: 'Learn to verify a PAN',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxMj1OUcDERLxvrxoOaWPsxwom39g2geoA&amp;clipt=EPrOHRjtnx8',
  },
  PAN_BATCH: {
    name: 'Learn to verify PAN in bulk',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=Ugkxe6MMc0SFl-_Wb1XaKIBDl8fCEdnn6ebe&amp;clipt=EJChHxjw9SI',
  },
  PAN_OCR: {
    name: 'Learn to verify PAN OCR',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxV5N-poprpuzIxcYf8FjPXN1xEFSR84Ov&amp;clipt=EJj7IhiN0yU',
  },
  AADHAAR: {
    name: 'How to verify an Aadhaar Number?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxcJjqlvHEVqAjnEpVc-lQYGiBYSzTV6b2&amp;clipt=EMDUJRigqSk',
  },
  AADHAAR_OCR: {
    name: 'How to verify an Aadhaar OCR?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxRl7eG-fSoLI--ZXMg__1zHjB6JUjQETp&amp;clipt=EKGPKhjo7iw',
  },
  ACCOUNTS: {
    name: 'How does Accounts section help?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxCcG8jOeKomxmXnL9bEX4qJeY4z5qzv3w&amp;clipt=ELXCMBiegDQ',
  },
  DEVELOPERS: {
    name: 'How to generate API keys?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=Ugkxd4VLtOQJlubaduWG6uRiuNeTm9iGaEaO&amp;clipt=EPDhOhij_Ts',
  },
  REPORTS: {
    name: 'How to download a Report?',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=UgkxnJqrWODEGObYJjSKNx4F98YELQUCA-tR&amp;clipt=EOWVOBi23jo',
  },
  SETTINGS: {
    name: 'Learn how the Settings help',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=Ugkx1QUCvOHHzNZPawQUBsP7yEFQEcfvAZ19&amp;clipt=EIX6OxiQ1T0',
  },

  GSTIN: {
    name: 'Learn to verify a GSTIN',
    url:
      'https://www.youtube.com/embed/FbP1Jyvvetk?clip=Ugkx1KBg0tQkfHHyRtnMRHwRxaluYUFsYE_j&amp;clipt=ELLtLBjLvzA',
  },
  'Bank Account using UPI': {
    name: 'Learn to verify using Reverse Penny Drop',
    url: 'https://www.youtube.com/embed/VIHnaGJUfrY?si=lNj8gQtkJJrAwjAt',
  },
};
